<template>
    <div>
      <div class="row">
        <div class="col-md-8">
          <card>
            <form class="form-horizontal" @submit.prevent="changePassword">
              <h4 slot="header" class="card-title">
                Change Password
              </h4>
              <div class="row">
                <label class="col-md-3 col-form-label">Old Password</label>
                <div class="col-md-9">
                  <fg-input
                    v-model="form.oldPassword"
                    placeholder="Old Password"
                    type="password"
                  ></fg-input>
                </div>
    
                <label class="col-md-3 col-form-label">New Password</label>
                <div class="col-md-9">
                  <fg-input
                    v-model="form.newPassword"
                    placeholder="New Password"
                    type="password"
                  ></fg-input>
                </div>
    
                <label class="col-md-3 col-form-label">Re-Enter New Password</label>
                <div class="col-md-9">
                  <fg-input
                    v-model="form.confirmPassword"
                    placeholder="Re-Enter New Password"
                    type="password"
                  ></fg-input>
                </div>
              </div>
    
              <div slot="footer" class="row">
                <label class="col-md-3"></label>
                <div class="col-md-9">
                  <p-button type="info" round @click="changePassword">
                    Change Password
                  </p-button>
                </div>
              </div>
            </form>
          </card>
        </div>
    
      </div>
  
      <!-- Category Manager -->
       <div class="row mt-4">
        <div class="col-md-12">
          <card>
            <h4 slot="header" class="card-title">Category Manager</h4>
            
            <div class="row">
                <!-- Left Side: Table of Contexts -->
                <div class="col-md-5">
                    <p class="text-muted">Select a section to manage categories.</p>
                    <el-table :data="contextList" @row-click="handleContextClick" style="width: 100%; cursor: pointer;" highlight-current-row>
                        <el-table-column prop="label" label="Section Name"></el-table-column>
                        <el-table-column width="50">
                             <template slot-scope="scope">
                                <i class="nc-icon nc-minimal-right"></i>
                             </template>
                        </el-table-column>
                    </el-table>
                </div>

                <!-- Right Side: Category Management for Selected Context -->
                <div class="col-md-7">
                    <div v-if="selectedContext" class="pl-4 border-left">
                        <div class="d-flex justify-content-between align-items-center">
                            <h5>Managing: <b>{{ selectedContext }}</b></h5>
                        </div>
                        <hr>

                        <div class="row mb-3">
                            <label class="col-md-3 col-form-label">Add New</label>
                            <div class="col-md-6">
                            <fg-input v-model="newCategory" placeholder="Category Name" @keyup.enter="addCategory"></fg-input>
                            </div>
                            <div class="col-md-3">
                            <p-button type="success" size="sm" @click="addCategory">Add</p-button>
                            </div>
                        </div>

                        <div class="category-list mt-3" ref="categoryList">
                            <div v-if="isLoadingCategories" class="text-center">Loading...</div>
                            <div v-else-if="categories.length === 0" class="text-center text-muted">No categories found.</div>
                            
                            <div v-for="cat in categories" :key="cat.id" class="category-item">
                                <span>{{ cat.name }}</span>
                                <p-button type="danger" size="sm" icon @click="deleteCategory(cat.id)">
                                <i class="nc-icon nc-simple-remove"></i>
                                </p-button>
                            </div>
                        </div>
                    </div>
                    <div v-else class="text-center text-muted p-5">
                        <i class="nc-icon nc-tap-01" style="font-size: 2em; margin-bottom: 10px;"></i>
                        <p>Click on a section from the table to view and edit its categories.</p>
                    </div>
                </div>
            </div>

          </card>
        </div>
      </div>
  
    </div>
    </template>
    
    <script>
    import { Card } from 'src/components/UIComponents';
    import { getAuth, updatePassword, reauthenticateWithCredential, EmailAuthProvider } from 'firebase/auth';
    import { db } from "@/firebase";
    import { collection, query, where, getDocs, addDoc, deleteDoc, doc, orderBy } from "firebase/firestore";
    import { Table, TableColumn, Button } from 'element-ui';
    import Swal from 'sweetalert2';
    
    export default {
      components: {
        Card,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Button.name]: Button
      },
      data() {
        return {
          form: {
            oldPassword: '',
            newPassword: '',
            confirmPassword: '',
          },
          // List of available contexts for the table
          contextList: [
            { value: 'RestaurantFood', label: 'Restaurant Food' },
            { value: 'RestaurantDrink', label: 'Restaurant Drink' },
            { value: 'LobbyFood', label: 'Lobby Food' },
            { value: 'LobbyDrink', label: 'Lobby Drink' },
            { value: 'LobbyBreakfast', label: 'Lobby Breakfast' },
            { value: 'LoungeFood', label: 'Lounge Food' },
            { value: 'LoungeDrink', label: 'Lounge Drink' },
            { value: 'RoomFood', label: 'Room Food' },
            { value: 'RoomDrink', label: 'Room Drink' }
          ],
          selectedContext: null, // Currently selected context value
          newCategory: '',
          categories: [],
          isLoadingCategories: false
        };
      },
      methods: {
        handleContextClick(row) {
            this.selectedContext = row.value;
            this.fetchCategories();
        },
        async fetchCategories() {
          if (!this.selectedContext) return;
          this.isLoadingCategories = true;
          this.categories = [];
          try {
            const q = query(
              collection(db, "CategoryOptions"), 
              where("type", "==", this.selectedContext)
            );
            const querySnapshot = await getDocs(q);
            const cats = [];
            querySnapshot.forEach((doc) => {
              cats.push({ id: doc.id, ...doc.data() });
            });
            // Client-side sort to avoid needing a composite index
            this.categories = cats.sort((a, b) => a.name.localeCompare(b.name));
          } catch (error) {
            console.error("Error fetching categories:", error);
          } finally {
            this.isLoadingCategories = false;
          }
        },
        async addCategory() {
          if (!this.newCategory.trim() || !this.selectedContext) return;
          
          const addedName = this.newCategory.toUpperCase();

          try {
            await addDoc(collection(db, "CategoryOptions"), {
              name: addedName,
              type: this.selectedContext,
              createdAt: new Date()
            });
            this.newCategory = '';
            await this.fetchCategories();
            
            // Auto-scroll to the new item
            this.$nextTick(() => {
                const index = this.categories.findIndex(c => c.name === addedName);
                if (index !== -1 && this.$refs.categoryList) {
                    const list = this.$refs.categoryList;
                    const items = list.getElementsByClassName('category-item');
                    if (items[index]) {
                        items[index].scrollIntoView({ behavior: 'smooth', block: 'center' });
                        items[index].classList.add('highlight-new');
                        setTimeout(() => items[index].classList.remove('highlight-new'), 2000);
                    }
                }
            });

            Swal.fire({
              icon: 'success',
              title: 'Added!',
              text: 'Category added successfully',
              timer: 1500,
              showConfirmButton: false
            });
          } catch (error) {
            console.error("Error adding category:", error);
            alert("Error adding category");
          }
        },
        async deleteCategory(id) {
            const result = await Swal.fire({
                title: 'Are you sure?',
                text: "Deleting this category will affect items listed under it! This action cannot be undone.",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Yes, delete it!'
            });

            if (result.isConfirmed) {
                try {
                    await deleteDoc(doc(db, "CategoryOptions", id));
                    this.fetchCategories();
                    Swal.fire(
                        'Deleted!',
                        'The category has been deleted.',
                        'success'
                    );
                } catch (error) {
                    console.error("Error deleting category:", error);
                    Swal.fire(
                        'Error!',
                        'There was a problem deleting the category.',
                        'error'
                    );
                }
            }
        },
        async changePassword() {
          const auth = getAuth();
          const user = auth.currentUser;
    
          if (!user) {
            alert('No user is logged in.');
            return;
          }
    
          const { oldPassword, newPassword, confirmPassword } = this.form;
    
          // Validate passwords
          if (newPassword !== confirmPassword) {
            alert('New passwords do not match.');
            return;
          }
          if (newPassword.length < 6) {
            alert('New password must be at least 6 characters.');
            return;
          }
    
          try {
            // Re-authenticate the user
            const credential = EmailAuthProvider.credential(user.email, oldPassword);
            await reauthenticateWithCredential(user, credential);
    
            // Update the password
            await updatePassword(user, newPassword);
            alert('Password changed successfully!');
            this.form.oldPassword = '';
            this.form.newPassword = '';
            this.form.confirmPassword = '';
          } catch (error) {
            console.error('Error changing password:', error.message);
            alert('Error: ' + error.message);
          }
        },
      },
    };
    </script>
  
  <style scoped>
  .category-list {
    max-height: 300px;
    overflow-y: auto;
    border: 1px solid #e3e3e3;
    border-radius: 4px;
    box-shadow: inset 0 0 5px rgba(0,0,0,0.05); /* subtle inner shadow to show depth */
    background-color: #fafafa;
  }
  /* Improve scrollbar visibility */
  .category-list::-webkit-scrollbar {
    width: 6px;
  }
  .category-list::-webkit-scrollbar-thumb {
    background-color: rgba(0,0,0,0.2);
    border-radius: 3px;
  }
  .category-list::-webkit-scrollbar-track {
    background: transparent;
  }

  .category-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 15px; /* Increase padding for better touch/look */
    border-bottom: 1px solid #eee;
    background-color: white;
    transition: background-color 0.3s;
  }
  .category-item:last-child {
      border-bottom: none;
  }
  .category-item:hover {
      background-color: #f9f9f9;
  }
  .highlight-new {
      background-color: #d4edda !important; /* Greenish tint for new items */
  }
  </style>
  
```